import type { ReactNode } from "react";

/** Les glyphes de l'interface guidée : traits fins, `currentColor`, jamais lus par un lecteur d'écran. */
function Icone({ taille = 20, children, plein = false }: { taille?: number; children: ReactNode; plein?: boolean }) {
  return (
    <svg
      width={taille}
      height={taille}
      viewBox="0 0 24 24"
      fill={plein ? "currentColor" : "none"}
      stroke={plein ? "none" : "currentColor"}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      style={{ flex: "none" }}
    >
      {children}
    </svg>
  );
}

export const IconeLecture = ({ taille }: { taille?: number }) => (
  <Icone taille={taille} plein>
    <path d="M8 5.5v13l11-6.5z" />
  </Icone>
);
export const IconePause = ({ taille }: { taille?: number }) => (
  <Icone taille={taille} plein>
    <path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" />
  </Icone>
);
export const IconePrecedent = ({ taille }: { taille?: number }) => (
  <Icone taille={taille} plein>
    <path d="M6 5h2v14H6zM19 5.5v13L9.5 12z" />
  </Icone>
);
export const IconeSuivant = ({ taille }: { taille?: number }) => (
  <Icone taille={taille} plein>
    <path d="M16 5h2v14h-2zM5 5.5v13L14.5 12z" />
  </Icone>
);
export const IconeSon = ({ coupe, taille }: { coupe: boolean; taille?: number }) => (
  <Icone taille={taille}>
    <path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z" />
    {coupe ? <path d="M16 9.5l5 5M21 9.5l-5 5" /> : <path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" />}
  </Icone>
);
export const IconeSousTitres = ({ taille }: { taille?: number }) => (
  <Icone taille={taille}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M10 10.5a2 2 0 1 0 0 3M17 10.5a2 2 0 1 0 0 3" />
  </Icone>
);
/** Bandes + écran : « reprendre le guide » remet les bandes. */
export const IconeBandes = ({ taille }: { taille?: number }) => (
  <Icone taille={taille}>
    <rect x="3" y="4" width="18" height="16" rx="1.5" />
    <path d="M3 8h18M3 16h18" />
  </Icone>
);
export const IconeChevron = ({ sens, taille }: { sens: "gauche" | "droite"; taille?: number }) => (
  <Icone taille={taille}>
    <path d={sens === "gauche" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7"} />
  </Icone>
);
export const IconeRejouer = ({ taille }: { taille?: number }) => (
  <Icone taille={taille}>
    <path d="M4 12a8 8 0 1 0 2.6-5.9M4 4v4.5h4.5" />
  </Icone>
);

export const IconeListe = ({ taille }: { taille?: number }) => (
  <Icone taille={taille}>
    <path d="M10 6h10M10 12h10M10 18h10" />
    <path d="M4 6l1.2 1.2L4 8.4 2.8 7.2zM4 12l1.2 1.2L4 14.4 2.8 13.2zM4 18l1.2 1.2L4 20.4 2.8 19.2z" />
  </Icone>
);
export const IconeChevronBas = ({ taille }: { taille?: number }) => (
  <Icone taille={taille}>
    <path d="M6 9l6 6 6-6" />
  </Icone>
);
export const IconeBoussole = ({ taille }: { taille?: number }) => (
  <Icone taille={taille}>
    <circle cx="12" cy="12" r="9" />
    <path d="M15.5 8.5l-2 5-5 2 2-5z" />
  </Icone>
);

export function Losange({ couleur, taille = 6 }: { couleur: string; taille?: number }) {
  return (
    <span
      aria-hidden
      style={{ width: taille, height: taille, background: couleur, transform: "rotate(45deg)", flex: "none", display: "inline-block" }}
    />
  );
}
